import { Link } from 'react-router-dom';
import usePageMeta from '../lib/usePageMeta';
import Icon from '../components/Icon';

export default function NotFound() {
  usePageMeta('Page not found', 'The page you are looking for does not exist.');
  return (
    <section className="relative flex min-h-[80vh] items-center overflow-hidden bg-ink pt-24 text-center text-white">
      <div className="grid-bg pointer-events-none absolute inset-0" />
      <div className="container-x relative">
        <p className="font-display text-8xl font-bold text-gradient sm:text-9xl" data-anim="zoom">404</p>
        <h1 className="mt-4 text-3xl font-bold sm:text-4xl" data-anim="up" data-delay="0.15">This page could not be found</h1>
        <p className="mx-auto mt-4 max-w-md text-white/65" data-anim="up" data-delay="0.25">The link may be broken or the page may have moved. Let’s get you back on track.</p>
        <div className="mt-8 flex flex-wrap justify-center gap-4" data-anim="up" data-delay="0.35">
          <Link to="/" className="btn-primary">Back to home <Icon name="arrow" className="h-4 w-4" /></Link>
          <Link to="/services" className="btn-ghost">Browse services</Link>
        </div>
      </div>
    </section>
  );
}
